import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="text-xl font-bold font-heading tracking-wide text-background-50">
              {siteInfo.name}
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-background-50/60">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-3 mt-4">
              {[
                { icon: 'ri-weibo-line', href: siteInfo.socialLinks.weibo, label: '微博' },
                { icon: 'ri-bilibili-line', href: siteInfo.socialLinks.bilibili, label: 'B站' },
                { icon: 'ri-tiktok-line', href: siteInfo.socialLinks.douyin, label: '抖音' },
                { icon: 'ri-vip-crown-line', href: siteInfo.socialLinks.xiaohongshu, label: '小红书' },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/training-plan" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors">
                  训练计划
                </Link>
              </li>
              <li>
                <Link to="/category/diet-plan" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors">
                  饮食方案
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line mt-0.5"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line mt-0.5"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-wechat-line mt-0.5"></i>
                <span>微信：{siteInfo.wechat}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <a href="#" className="hover:text-primary-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-300 transition-colors">服务条款</a>
            <a href="#" className="hover:text-primary-300 transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}